module.exports = __webpack_public_path__ + "img/637025874489779904Zelfbeeld.png";